/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react"
import { addLine } from "../../BackendServices/registrationAPI"
import { withTranslation } from "react-i18next"
import Title from "../common/Title"
import Description from "../common/Description"
import TextInput from "../common/TextInput"
import CheckBoxRadioInput from "../common/CheckBoxRadioInput"
import ActivationCode from "./ActivationCode"
import SuccessScreen from "./SuccessScreen"
import { encrypt } from "../../BackendServices/generic"
import ErrorAlert from "../common/ErrorAlert"
import BackArrow from '../../assets/back-arrow.svg';

const win = window;

class AddLineDetails extends Component {

    constructor(props) {
        let accountType = '';

        if (props.clientInfo["gsm"] === 'Y') {
            accountType = 'gsm'
        } else if (props.clientInfo["connect"] === 'Y') {
            accountType = 'connect'
        } else if (props.clientInfo["ftth"] === 'Y') {
            accountType = 'ftth'
        }
        super(props)
        this.state = {
            accountType: accountType,
            accountNumber: '',
            phoneNumber: '',
            dataSIM: '',
            serviceNumber: '',
            idNumber: '',
            checkedType: '',
            errors: { accountNumber: '', phoneNumber: '', dataSIM: '', serviceNumber: '', idNumber: '' },
            errorType: { accountNumberClassName: '', phoneNumberClassName: '', dataSIMClassName: '', serviceNumberClassName: '', idNumberClassName: '' },
            goToActivationCode: false,
            goToSuccessScreen: false,
            genericError: null,
            loading: false
        }
    }

    addLine = async (e) => {
        let accountNo = '';
        if (this.state.accountType === 'gsm') {
            accountNo = this.state.phoneNumber
        } else if (this.state.accountType === 'connect') {
            accountNo = this.state.dataSIM
        } else if (this.state.accountType === 'ftth') {
            accountNo = this.state.serviceNumber
        }

        let requestBody = {
            "transactionId": this.props.transactionId,
            "idNumber": encrypt(this.state.idNumber),
            "lineInformation": {
                "accountType": this.state.accountType,
                "accountNumber": encrypt(accountNo)
            },
            "clientInfo": {
                "clientId": this.props.clientId,
                ...(this.props.clientId !== window.OAUTHUserName && { "redirectUrl": this.props.redirectURL })

            }
        }
        await this.setState({
            loading: true
        })
        try {
            let result = await addLine(requestBody)
            win.MixpanelTracker.trackEvent("Verification Completed", {
                idv_method: this.state.accountType === 'connect' ? 'Data' : 'Fiber'
            });
            if (this.state.accountType === 'gsm') {
                this.setState({
                    goToActivationCode: true,
                    loading: false
                })
            } else {
                this.setState({
                    goToSuccessScreen: true,
                    loginUrl: result.loginUrl,
                    loading: false
                })
            }
        } catch (error) {
            win.MixpanelTracker.trackEvent("Verification Failed", {
                error_code: error.code,
                error_message : error.message,
                idv_method: this.state.accountType === 'connect' ? 'Data' : 'Fiber'
            });
            this.setState({
                genericError: error.message,
                loading: false
            })
        }
    }

    handleValidation(formData) {
        let errors = {};
        let errorType = {};
        let formIsValid = false;

        for (var [key, value] of formData) {

            if (this.state.accountType === 'gsm') {
                if (key === 'phoneNumber') {
                    if (value === null || value === '') {
                        errors['phoneNumber'] = "required";
                        errorType['phoneNumberClassName'] = "validation-error";
                    } else if (typeof value !== "undefined") {
                        if (!value.match(/^(9665)([0-9]{8})$/)) {
                            errors['phoneNumber'] = "msisdn_format";
                            errorType['phoneNumberClassName'] = "validation-error";
                        }
                    }
                }

                if (key === 'idNumber') {
                    if (value === null || value === '') {
                        errors['idNumber'] = "required";
                        errorType['idNumberClassName'] = "validation-error";
                    }
                }
            }
            if (this.state.accountType === 'connect') {
                if (key === 'dataSIM') {
                    if (value === null || value === '') {
                        errors['dataSIM'] = "required";
                        errorType['dataSIMClassName'] = "validation-error";
                    } else if (typeof value !== "undefined") {
                        if (!value.match(/^((966)([0-9]{12})||(96618)([0-9]{7}))$/)) {
                            errors['dataSIM'] = "data_sim_format";
                            errorType['dataSIMClassName'] = "validation-error";
                        }
                    }
                }

                if (key === 'idNumber') {
                    if (value === null || value === '') {
                        errors['idNumber'] = "required";
                        errorType['idNumberClassName'] = "validation-error";
                    }
                }
            }
            if (this.state.accountType === 'ftth') {
                if (key === 'serviceNumber') {
                    if (value === null || value === '') {
                        errors['serviceNumber'] = "required";
                        errorType['serviceNumberClassName'] = "validation-error";
                    } else if (typeof value !== "undefined") {
                        if (!value.match(/^(8\d{11}|PR8\d{11}|DP8\d{11}|100\d{12,27}|PR100\d{10,25}|DP100\d{10,25})$/)) {
                            errors['serviceNumber'] = "service_account_format";
                            errorType['serviceNumberClassName'] = "validation-error";
                        }
                    }
                }

                if (key === 'idNumber') {
                    if (value === null || value === '') {
                        errors['idNumber'] = "required";
                        errorType['idNumberClassName'] = "validation-error";
                    }
                }
            }
        }
        if ((JSON.stringify(errors) === '{}')) {
            formIsValid = true
        }

        this.setState({
            errors: errors,
            errorType: errorType
        });

        return formIsValid;
    }

    handaleSubmit = async (e) => {
        const formData = new FormData(e.target);
        let formIsValid = false;
        formIsValid = this.handleValidation(formData.entries())
        e.preventDefault()

        if (formIsValid) {
            await this.addLine();
        }
    }

    handleChange = async e => {
        e.persist();

        await this.setState({
            idNumber: e.target.name === 'accountType' ? '' : this.state.idNumber,
            errors: e.target.name === 'accountType' ? { ...this.state.errors, idNumber: '' } : { ...this.state.errors },

            [e.target.name]: e.target.value,
        })
    }

    render() {
        const { t } = this.props;

        return (
            <>
                {this.state.loading && <div className="loading">Loading&#8230;</div>}
                {!this.state.goToActivationCode && !this.state.goToSuccessScreen &&
                    <section>
                        <div className="loginIntroTextContainer">
                            <a className="emailRegBackButton" onClick={this.props.handleBack}>
                                <img src={BackArrow} alt='back' />
                            </a>
                            <Title title={"add_line_title"} />
                        </div>
                        <div className="tabs">
                            <div className="tab-content">
                                {this.state.genericError && (
                                    <>
                                        <ErrorAlert error={this.state.genericError} />
                                        <div style={{ display: "none" }} className={this.state.genericError ? "api-error" : ""}>{this.state.genericError}</div>
                                    </>
                                )}
                                <form onSubmit={this.handaleSubmit} id={'addLine-detail-form'}>

                                    {/* LINE TYPE */}
                                    <CheckBoxRadioInput id="mobile-line" label={"add_mobile_line"} name={"accountType"} value="gsm" type={"radio"} handleChange={this.handleChange} checked={this.state.accountType === 'gsm'} disabled={this.props.clientInfo['gsm'] === 'N'} />
                                    <CheckBoxRadioInput id="data-line" label={"add_data_line"} name={"accountType"} value="connect" type={"radio"} handleChange={this.handleChange} checked={this.state.accountType === 'connect'} disabled={this.props.clientInfo['connect'] === 'N'} />
                                    <CheckBoxRadioInput id="fiber-line" label={"add_fiber_line"} name={"accountType"} value="ftth" type={"radio"} handleChange={this.handleChange} checked={this.state.accountType === 'ftth'} disabled={this.props.clientInfo['ftth'] === 'N'} />

                                    {/* PHONE NUMBER FIELD */}
                                    {this.state.accountType === 'gsm' &&
                                        <TextInput id="phoneNumber" label={"mobily_phone_number"} name={"phoneNumber"} value={this.state.phoneNumber} type={"text"} error={this.state.errors.phoneNumber} errorType={this.state.errorType.phoneNumberClassName} handleChange={this.handleChange} />
                                    }
                                    {/* DATA SIM FIELD */}
                                    {this.state.accountType === 'connect' &&
                                        <TextInput id="dataSIM" label={"data_sim"} name={"dataSIM"} value={this.state.dataSIM} type={"text"} error={this.state.errors.dataSIM} errorType={this.state.errorType.dataSIMClassName} handleChange={this.handleChange} />
                                    }
                                    {/* SERVICE ACCOUNT FIELD */}
                                    {this.state.accountType === 'ftth' &&
                                        <TextInput id="serviceNumber" label={"service_account_no"} name={"serviceNumber"} value={this.state.serviceNumber} type={"text"} error={this.state.errors.serviceNumber} errorType={this.state.errorType.serviceNumberClassName} handleChange={this.handleChange} hint={"service_account_no_hint"} />
                                    }

                                    {/* NATIONAL ID FIELD */}
                                    <TextInput id="nationalIdNumber" label={"national_number"} name={"idNumber"} value={this.state.idNumber} type={"text"} error={this.state.errors.idNumber} errorType={this.state.errorType.idNumberClassName} handleChange={this.handleChange} />


                                    <button id="addLine-button" type="submit" className="btn min_outlin_btn active">
                                        {this.state.accountType === 'gsm' ? t("verify_number") : t("submit_btn")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                    </button>

                                </form>
                            </div>
                        </div>
                    </section>}
                {this.state.goToActivationCode && <ActivationCode redirectURL={this.props.redirectURL} from={'addLine'} addLine={this.addLine} transactionId={this.props.transactionId} msisdn={this.state.phoneNumber} clientInfo={this.props.clientInfo} clientId={this.props.clientId} />}
                {this.state.goToSuccessScreen && <SuccessScreen description={"enjoy_of_our_services"} loginUrl={this.state.loginUrl} />}
            </>
        )
    }
}
export default withTranslation()(AddLineDetails);
